import { render, staticRenderFns } from "./StatusIcon.vue?vue&type=template&id=8d6cd78a&scoped=true&"
import script from "./StatusIcon.vue?vue&type=script&lang=js&"
export * from "./StatusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6cd78a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d6cd78a')) {
      api.createRecord('8d6cd78a', component.options)
    } else {
      api.reload('8d6cd78a', component.options)
    }
    module.hot.accept("./StatusIcon.vue?vue&type=template&id=8d6cd78a&scoped=true&", function () {
      api.rerender('8d6cd78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StatusIcon.vue"
export default component.exports